interface LinearAudioLevelsProps {
  levels: number[]
  barCount?: number
  className?: string
}

export function LinearAudioLevels({
  levels,
  barCount = 24,
  className,
}: LinearAudioLevelsProps) {
  // Cap at bin 150 (~7kHz regardless of 44.1k or 48k sample rate).
  // Upper bins are near-silent for speech/voice.
  const usableBins = Math.min(levels.length, 150)
  const binsPerBar = Math.max(1, Math.floor(usableBins / barCount))

  return (
    <div className={`flex items-center gap-0.5 ${className ?? ""}`}>
      {Array.from({ length: barCount }, (_, i) => {
        let sum = 0
        const start = i * binsPerBar
        const end = Math.min(start + binsPerBar, usableBins)
        for (let j = start; j < end; j++) sum += levels[j] ?? 0
        const avg = sum / (end - start || 1)

        // Mild EQ boost toward higher bars within the usable range
        const t = usableBins > 1 ? start / usableBins : 0
        const eq = Math.min(1, avg * (1 + t * 0.8))
        const height = Math.max(0.08, eq ** 0.6)

        return (
          <div
            key={i}
            className="w-[3px] rounded-full bg-brand-slate/60 transition-all duration-100"
            style={{ height: `${height * 28}px` }}
          />
        )
      })}
    </div>
  )
}
